import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {SimpleReelModel} from "../../core/reel/simplereel/SimpleReelModel";
import {BruteForce} from "../BruteForce";
import {gsap, Linear} from "gsap";
import {BruteForceGameConfig} from "../BruteForceGameConfig";
import {BruteForceGameMode} from "../server/BruteForceGameMode";
import {TimelineSprite} from "@nolimitcity/promo-panel/bin/utils/TimelineSprite";
import {BLEND_MODES} from "pixi.js";
import {BruteForceReelSet} from "./BruteForceReelSet";
import {CustomWiggle} from "gsap/dist/CustomWiggle";
import {BruteForceSound} from "../sound/BruteForceSound";

export class BruteForceReelsArea extends PIXI.Container implements StageLayer {

    get reelModels(): SimpleReelModel[] {
        return this._reelModels;
    }

    private _reelModels: SimpleReelModel[];

    private symbolWidth: number = 120;
    private symbolHeight: number = 96;
    public static stepDuration: number = 0.045;
    public static reelStopDelay: number = BruteForceReelsArea.stepDuration * 3;
    public static reelStopDelayFastSpin: number = BruteForceReelsArea.stepDuration;


    constructor() {
        super();
        this.position.set(BruteForceGameConfig.reelSetPositionX, BruteForceGameConfig.reelSetPositionY);
        this.scale.set(1.2, 1.2)
        this.init();
    }

    private init() {
        const symbolMask = new PIXI.Graphics();
        symbolMask.beginFill(0xFFF678, 1);
        symbolMask.drawRect(-60, -48, this.symbolWidth * 5, this.symbolHeight * 5);
        this.addChild(symbolMask);
        this.mask = symbolMask;

        this._reelModels = [];
        for (let i: number = 0; i < 5; i++) {
            const reel = new SimpleReelModel(i, true);
            reel.setReelSet(!BruteForce.model.nextMode.includes("NORMAL") ? BruteForceReelSet.BONUS_GAME_REELSET[i] : BruteForceReelSet.BASE_GAME_REELSET[i]);
            reel.stepSize = this.symbolHeight;
            reel.init(BruteForce.model.data.reels[i].concat());

            this._reelModels.push(reel);
            this.addChild(reel.reelView);
        }


    }

    public dropReelSetAnimation(): gsap.core.Timeline {
        const dropTl: gsap.core.Timeline = gsap.timeline();
        this._reelModels.forEach((reelModel: SimpleReelModel, index: number) => {
            const reelBlast: TimelineSprite = new TimelineSprite(BruteForce.assetLoader.getTextures("reelDropBlast"));
            const blastTl: gsap.core.Timeline = gsap.timeline();
            reelBlast.name = `blast_${index}`;
            reelBlast.blendMode = BLEND_MODES.ADD
            reelBlast.position.set(BruteForceGameConfig.reelSetPositionX + index * (BruteForceGameConfig.symbolWidth) - 130, BruteForceGameConfig.reelSetPositionY + 2 * (BruteForceGameConfig.symbolHeight) + 15);
            blastTl.add(() => {
                this.addChild(reelBlast);
                reelBlast.show();
            }, 0);
            blastTl.add(reelBlast.getAnimationAutoShowHide());
            blastTl.add(() => {
                this.removeChild(reelBlast);
            });
            // blastTl.totalDuration(0.15);
            reelModel.reelView.position.y = -790;
            dropTl.to(reelModel.reelView, {duration: 0.3, y: 0, ease: "power1.inOut"}, index === 0 ? 0 : ">-0.3");
            dropTl.add(blastTl, ">-0.1");
            dropTl.add(BruteForce.gameContainer.screenShake(0.15, 100, true), "<");
        });
        if (BruteForce.model.nextMode !== BruteForceGameMode.NORMAL) {
            dropTl.to(this, {duration: 0.5});
        }
        return dropTl;
    }

    public changeReelSet(): void {
        for (let i: number = 0; i < 5; i++) {
            this._reelModels[i].setReelSet(!BruteForce.model.nextMode.includes("NORMAL") ? BruteForceReelSet.BONUS_GAME_REELSET[i] : BruteForceReelSet.BASE_GAME_REELSET[i]);
        }
    }

    public shakeReelArea(): gsap.core.Timeline { //prebigwinshake
        const moveXVal: number = 7,
            moveYVal: number = 7,
            shakeTL: gsap.core.Timeline = gsap.timeline(),
            x: string = `+=${moveXVal}`,
            y: string = `+=${moveYVal}`;

        const shakeWiggle = CustomWiggle.create("ReelAreaWiggle", {
            wiggles: 70,
            amplitudeEase: Linear.easeNone,
            timingEase: Linear.easeNone
        });

        shakeTL.to(this, {
            duration: 0.69,
            x: x,
            ease: shakeWiggle
        }, 0);
        shakeTL.to(this, {
            duration: 0.69,
            y: y,
            ease: shakeWiggle
        }, 0);
        shakeTL.to(this, {
            x: BruteForceGameConfig.reelSetPositionX,
            y: BruteForceGameConfig.reelSetPositionY,
            duration: 0.01
        });
        shakeTL.add(() => {
            BruteForceSound.playTrack(BruteForceSound.BIGWIN_INTRO);
        }, 0);
        return shakeTL;
    }

}